import React, { useEffect, useState } from "react";
import { Button } from "../shadcn/components/ui/button";
import LoadingButton from "./Common/LoadingButton";
import StatusAlert from "./Common/StatusAlert";
import LabeledTextField from "./Common/LabeledTextField";
import { EDIT_USER } from "../graphql/userGraphql";
import { useTranslation } from "../context/Internationalization";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../shadcn/components/ui/dialog";

export const parseContactPhones = (value) =>
  Array.from(
    new Set(
      value
        .split(/[,\n]+/)
        .map((phone) => phone.trim())
        .filter(Boolean)
    )
  );

const ContactPhoneModal = ({
  open,
  onClose,
  user,
  axiosGraphQL,
  onCompleted,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setValue((user?.contactInfo?.phones || []).join(", "));
      setStatus("idle");
      setError("");
    }
  }, [open, user?.contactInfo?.phones]);

  const close = () => {
    if (status === "pending") return;
    setStatus("idle");
    setError("");
    onClose();
  };

  const submit = async (event) => {
    event.preventDefault();
    if (status === "pending") return;

    setStatus("pending");
    setError("");
    try {
      await axiosGraphQL({
        query: EDIT_USER,
        variables: { contactPhones: parseContactPhones(value) },
      });
      await onCompleted();
      onClose();
    } catch {
      setError(t("contact_phone_save_failed"));
      setStatus("idle");
    }
  };

  const title = t("edit_contact_phone");

  return (
    <Dialog
      open={Boolean(open)}
      onOpenChange={(next, details) => !next && close(details?.event)}
    >
      <DialogContent closeLabel={t("close")}>
      <form className="contents" onSubmit={submit}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex min-w-0 flex-col gap-4">
          <div className="flex w-full flex-col gap-4">
            {error && <StatusAlert severity="error">{error}</StatusAlert>}
            <LabeledTextField
              autoFocus
              multiline
              minRows={2}
              label={t("contact_phone")}
              helperText={t("contact_phone_helper")}
              value={value}
              disabled={status === "pending"}
              onChange={(event) => setValue(event.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={close}
            disabled={status === "pending"}
          >
            {t("cancel")}
          </Button>
          <LoadingButton
            type="submit"
            loading={status === "pending"}
          >
            {t("save")}
          </LoadingButton>
        </DialogFooter>
      </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactPhoneModal;
